import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MigasService } from '../../services/migas.service';

/**
 * Ruta de navegación (migas de pan) en la cabecera: Inicio › Asociaciones › Foguera X. Va dentro de la cabecera de 92 px (no añade
 * ninguna franja) para no desplazar los fondos y alturas calculadas de las pantallas. En móvil se reduce al enlace al nivel superior.
 */
@Component({
  selector: 'app-migas',
  standalone: true,
  imports: [CommonModule, RouterLink],
  styles: [':host { display: block; }'],
  template: `
    @if (migas.migas().length > 1) {
      <div class="app-header__crumbs">
        <div class="crumbs-inner crumbs">
          <nav aria-label="Ruta de navegación" class="d-none d-md-block w-100" data-testid="migas">
            <ol>
              @for (miga of migas.migas(); track $index; let ultima = $last) {
                <li [class.active]="ultima" [attr.aria-current]="ultima ? 'page' : null" data-testid="miga">
                  @if (miga.url && !ultima) { <a [routerLink]="miga.url">{{ miga.texto }}</a> } @else { {{ miga.texto }} }
                </li>
              }
            </ol>
          </nav>
          @if (migas.padre(); as padre) {
            @if (padre.url) {
              <a class="crumb-back d-md-none" [routerLink]="padre.url" data-testid="miga-padre"><i class="bi bi-chevron-left" aria-hidden="true"></i> {{ padre.texto }}</a>
            }
          }
        </div>
      </div>
    }
  `
})
export class MigasComponent {
  constructor(protected readonly migas: MigasService) {}
}
